<template>
  <v-flex
    shrink
    class="text-xs-center"
    mx-2
    pa-1
  >
    <p>{{ person.relation }}</p>
    <p class="mb-0">
      {{ person.changedName }}
    </p>
    <p>{{ person.age }} {{ person.ageOption }}</p>
    <p
      v-if="!hideRealNames"
      class="f-14"
    >
      {{ $t('description.family_introduction.original_name') }} {{ person.firstName }}
    </p>
  </v-flex>
</template>

<script>
export default {
    name: 'FamilyAvatar',
    props: {
        person: {
            required: true
        },
        hideRealNames: {
            default: false
        }
    }
};
</script>

<style scoped>
.f-14 {
  font-size: 14px !important;
}
</style>
